<template>
  <div>
    <div v-if="courseList.list.length > 0">
      <div class="center name">
        <!-- <el-image
        :src="$domain + image"
        alt="少儿编程"
        style="width: 425px;height: 50px;margin-top: 80px;"
      ></el-image> -->
        {{ courseList.name }}
      </div>
      <div class="center">
        <div class=" content">
          <div
            class="item"
            v-for="(i, index) in courseList.list"
            :key="index"
            @click="toPath"
          >
            <router-link
              tag="a"
              target="_blank"
              :to="{ name: 'videoCourseDetail', query: { tid: 1 } }"
            >
            </router-link>
            <el-image
              :src="$domain + i.cover"
              alt="少儿编程"
              style="width: 350px;height: 254px;border-radius: 20px 20px 0px 0px;"
            ></el-image>
            <div class="column-space info">
              <div class="info-title">{{ i.title }}</div>
              <div class="info-label center-just">{{ i.count }}课次</div>
              <div class="info-price">
                <span class="symbol">￥</span>
                <span class="price">{{ i.sku.price }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="center" @click="getMoreCourse(id)" v-show="isMore">
        <div class="center-just more">更多课程</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { videoCourseList } from "@/api/port";
export default {
  props: ["courseList", "id"],
  data() {
    return {
      isMore: true
    };
  },
  methods: {
    getMoreCourse(tid) {
      this.isMore = false;
      api
        .post(videoCourseList.getMoreCourseList, { tid: tid })
        .then(res => {
          // this.dataList = res.list;
          this.courseList.list = res.list;
        })
        .catch(error => {
          // 捕获异常并处理
          console.error("Error:", error);
        });
    },
    toPath() {
      // videoCourseDetail
      let routeOne = this.$router.resolve({
        name: "videoCourseDetail",
        query: {
          tid: 1
        }
      });
      window.open(routeOne.href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 1200px;
  margin-top: 70px;
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 350px;
    height: 480px;
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0px 0px 10px 0px #eeecec;
    caret-color: transparent;
    cursor: pointer;
    margin: 40px 25px 40px 25px;
    // display: inline-block;
    .info {
      height: 226px;
      margin: 0px 15px 0px 15px;
      .info-title {
        line-height: 28px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #1a1a1a;
      }
      .info-label {
        width: 76px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #c8ced4;
        border-radius: 4px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #666666;
        letter-spacing: 1px;
      }
      .info-price {
        .symbol {
          width: 10px;
          height: 11px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #1966ff;
        }
        .price {
          width: 18px;
          height: 26px;
          font-size: 32px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #1966ff;
        }
      }
    }
  }
}
.more {
  width: 240px;
  height: 52px;
  border: 1px solid #c8ced4;
  border-radius: 10px;
  margin: 70px 0px 70px 0px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  cursor: pointer;
  caret-color: transparent;
}
.name {
  // width: 352px;
  height: 60px;
  font-size: 46px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #1a1a1a;
  margin-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/videoCourse/components/courseList.vue